import {Component, Output, EventEmitter, Input} from '@angular/core';
import { ExportToCsv } from 'export-to-csv';

import { OrgService } from '../services/org.service';
import { Package, CDSNode } from '../services/capd.model';

@Component({
  selector: 'company-delete-package',
  templateUrl: './company-delete-package.component.html',
  // inputs: ['package', 'org', 'csvData']
})

/**
 * Deletes the assignment of a package to an org.
 */
export class CompanyDeletePackageComponent {
  isDisabled = true;
  @Output() update = new EventEmitter();
  @Input() org: CDSNode;
  @Input() package: Package;
  @Input() csvData: any;

  constructor(private _service: OrgService) { }

  /**
   * Toggle checkbox that disables the delete button by default.
   *
   * @func toggleDisabled
   */
  toggleDisabled() {
    this.isDisabled = !this.isDisabled;
  }

  /**
   * Removes the package assignment from the company/org.
   *
   * @async
   * @func onDelete
   */
  onDelete() {
    this._service.removePackageFromOrg(this.package.id, this.org.rootId).then(() => {this.update.emit(null); });
  }

  /**
   * Saves a copy of the current rule assignments to a local computer as a .csv file.
   *
   * @func exportCsv
   */
  exportCsv() {
    // new Angular2CsvModule();
    // new Angular2Csv(this.csvData, this.org.description + '_Packages');
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Company Package Export CSV',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(this.csvData);
  }
}
